import React from 'react'
import styled from 'styled-components'
import {Box} from '@mui/material'

export const NatDoNotifyNotice = () => {
    return (
        <Box width={'396px'}>
            <div>
                設定にチェックを入れると、掲載開始日に、メッセージを掲載する物件の居住者の方へ通知をします。注意事項をご確認の上、設定してください。
            </div>
            <br/>
            【注意事項】
            <ListGridContainer>
                <div>・</div>
                <div>商用の内容を含むメッセージは、通知を設定しないでください</div>
                <div>・</div>
                <div>重要なメッセージのみ、通知を設定してください</div>
                <div>・</div>
                <div>通知文にはタイトルとカテゴリが含まれるため、正しく設定してください</div>
                <div>・</div>
                <div>通知したメッセージは、削除できません</div>
                <div>・</div>
                <div>通知したメッセージは、再度通知できません</div>
            </ListGridContainer>
        </Box>
    )
}

const ListGridContainer = styled.div`
    display: grid;
    grid-template-columns: min-content auto;
    padding-left: 5px;
`
